<div class="loading" *ngIf="loading; else loaded"></div>
<ng-template #loaded>
  @if (placeCount > 0) {
    <table>
      <thead>
      <tr>
        <th>Этаж</th>
        <th>Площадь</th>
        <th [attr.colspan]="maxPlacesCount">
          Пятно {{ buildingNumber }} / Д {{ houseNumber }} / {{roomTypeID === RoomTypeEnum.Commercial ? 'Коммерческих помещений' : 'Паркомест'}} {{ placeCount }}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let group of [groupedFloors, groupedFloorsParking1, groupedFloorsParking2]">
        <ng-container *ngFor="let floor of group">
          <tr *ngIf="floor.places.length">
            <td class="floor"> {{ floor.roomTypeItemID === 11 ? 'P' : '' }} {{ floor.floorNumber }}</td>
            <td class="area">{{ ((floor.totalArea | round | numberWithSpaces: 'twoDecimals')+ ' м²') || '-' }}</td>
            <ng-container *ngFor="let place of floor.places; let i = index">
              <!-- (click)="isSalesMode ? openSaleDialog(place, floor.floorID) : (roomTypeID === RoomTypeEnum.Commercial ? openPlace(place, floor) : openParking(place, floor))" -->
              <!-- [matTooltip]="isSalesMode ? (checkPlace(place) ? warningMessage : '') : ''" -->
              <td class="place"
              (click)="openPlaceInfo(place, floor)"
              [class.sales-mode]="isSalesMode ? checkPlace(place) : false"
              [class.is-sold]="isSold(place)">
                <div class="place-wrapper">
                  <span>№{{ place.placeNumber }}</span>
                  <span>{{ place.area | numberWithSpaces: 'twoDecimals'}}{{place.area? ' м²' : ''}}</span>
                  <span>{{ place.roomTypeItemTitle }}</span>
                </div>
                <!--  -->
                <span *ngIf="!isSalesMode && !isSold(place)" class="icon-remove" (click)="deleteRoom(place.id, i, floor); $event.stopPropagation()">✕</span>
              </td>
            </ng-container>
            <!-- Дополнительные пустые ячейки, если мест меньше максимума -->
            <ng-container *ngIf="floor.places.length < maxPlacesCount">
              <td class="place" *ngFor="let empty of [].constructor(maxPlacesCount - floor.places.length)">
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
  } @else if (groupedFloors.length === 0) {
    нет данных
  }
</ng-template>

@if(deleteLoading) {
  <div class="delete-loading-wrapper">
    <div class="loading"></div>
  </div>
}
